import type {ReactElement} from 'react';
import React from 'react';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import type {PublishingVizromPanelProps} from './publishing-vizrom-panel.types';
import {getProductUsed} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';

export function PublishingVizromPanel({...props}: PublishingVizromPanelProps): ReactElement {
  const productUsed = getProductUsed();
  const applicationVariablesJSON = window.PMW.util.escapeHTML(`applicationVariables={"designId":"${productUsed?.hashedId}"}`);

  const vizromLink = `https://signage.vizrom.com/postermywall?${applicationVariablesJSON}`;

  return (
    <DigitalSignageSubPanel
      panelHeading={window.i18next.t('pmwjs_vizrom')}
      heading={window.i18next.t('pmwjs_vizrom_digital_signage')}
      subheading={window.i18next.t('pmwjs_vizrom_desc')}
      showButton
      onClose={props.onClose}
      buttonText={window.i18next.t('pmwjs_go_to_vizrom')}
      onClick={() => {
        window.open(vizromLink, '_blank');
      }}
      imgSrc="publishing-vizrom.png"
    />
  );
}
